/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.threads.drafts.rpc.DraftsFrontendService
 */

export const AiInferenceMetadataTypename = 'com.hubspot.cv.pubsub.core.message.common.AiInferenceMetadata';
export const CallMetadataTypename = 'com.hubspot.cv.pubsub.core.message.common.CallMetadata';
export const CitationTypename = 'com.hubspot.cv.pubsub.core.message.common.Citation';
export const ContactAttachmentTypename = 'com.hubspot.cv.pubsub.core.message.common.ContactAttachment';
export const CustomerAgentAssignmentTypename = 'com.hubspot.cv.pubsub.core.message.common.CustomerAgentAssignment';
export const EmailMetadataTypename = 'com.hubspot.cv.pubsub.core.message.common.EmailMetadata';

/**
 * Virtual record for map with known enum keys
 */

export const FilesTypename = 'com.hubspot.cv.pubsub.core.message.common.Files';
export const InlineImagesTypename = 'com.hubspot.cv.pubsub.core.message.common.InlineImages';
export const LocationTypename = 'com.hubspot.cv.pubsub.core.message.common.Location';
export const MentionsTypename = 'com.hubspot.cv.pubsub.core.message.common.Mentions';
export const MessageHeaderTypename = 'com.hubspot.cv.pubsub.core.message.common.MessageHeader';
export const MessagePositionDescriptorTypename = 'com.hubspot.cv.pubsub.core.message.common.MessagePositionDescriptor';
export const QuickRepliesTypename = 'com.hubspot.cv.pubsub.core.message.common.QuickReplies';
export const RichMediaTemplatesTypename = 'com.hubspot.cv.pubsub.core.message.common.RichMediaTemplates';
export const SocialMetadataAttachmentTypename = 'com.hubspot.cv.pubsub.core.message.common.SocialMetadataAttachment';
export const UnsupportedContentAttachmentTypename = 'com.hubspot.cv.pubsub.core.message.common.UnsupportedContentAttachment';
export const WhatsAppTemplateMetadataTypename = 'com.hubspot.cv.pubsub.core.message.common.WhatsAppTemplateMetadata';
export let ComHubspotCvThreadsDraftsRpcModels;
(function (_ComHubspotCvThreadsDraftsRpcModels) {})(ComHubspotCvThreadsDraftsRpcModels || (ComHubspotCvThreadsDraftsRpcModels = {}));
export let ComHubspotCvThreadsDraftsRpcModelsV2;
(function (_ComHubspotCvThreadsDraftsRpcModelsV) {})(ComHubspotCvThreadsDraftsRpcModelsV2 || (ComHubspotCvThreadsDraftsRpcModelsV2 = {}));
export const upsertDraftRpc = {
  serviceName: 'com.hubspot.cv.threads.drafts.rpc.DraftsFrontendService',
  rpcName: 'upsertDraft',
  auth: 'app',
  fingerprint: 'B6dBQkFbut_sqKfr0PbPbBcytmmHPtEY',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteDraftRpc = {
  serviceName: 'com.hubspot.cv.threads.drafts.rpc.DraftsFrontendService',
  rpcName: 'deleteDraft',
  auth: 'app',
  fingerprint: 'pBh-fQEujYM5wDdkU00U2rRolttlYLrU',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getDraftsRpc = {
  serviceName: 'com.hubspot.cv.threads.drafts.rpc.DraftsFrontendService',
  rpcName: 'getDrafts',
  auth: 'app',
  fingerprint: 'EQqM1mLno9_0eT_YB5ppZqsmjQbTWC6f',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};